export const UPDATE_TRACKING_DATA = 'UPDATE_TRACKING_DATA'

export function trackingIdAndAnonymousLocalReducer (state = ["", ""], action) {
    switch (action.type){
        case UPDATE_TRACKING_DATA:
            return action.payload
        default: return state
    }
}